import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, CardBody, Button, Input } from 'reactstrap';
import Select from 'react-select';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getSelectedGroup,
  setSelectedGroup,
  getUserID,
} from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Internal_Property_List,
  gAPI_CheckUser_Property,
} from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CreatePropertyForm from './components/forms/CreatePropertyForm';
import UpdatePropertyForm from './components/forms/UpdatePropertyForm';
import { gAPI_Groups } from '../../../../../../constants/APIs';
import {
  reactSelectOptionDiffrentProWithKeyValue,
  sortPropertyListByName,
  reactSelectOptionDiffrentPro,
} from '../../../../../../helpers/Utils';
import ReactTable from 'react-table';
import GroupTablePagination from '../../../../../../components/GroupTablePaginate';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Index({ propertyId, history, activeGroup, service }) {
  const [propertiesList, setPropertiesList] = useState([]);
  const [groupList, setGroupsList] = useState([]);
  const [groupId, setGroupId] = useState(getGroupID());
  const [SelectedValue, DropdownSelectedValue] = useState(getSelectedGroup());
  const [loading, setLoading] = useState(true);
  const [groupCurrency, setGroupCurrency] = useState('');
  const [filteredData, setFilterData] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filterCountry, setFilterCountry] = useState('');
  const [filterPropertyName, setFilterPropertyName] = useState('');
  const [filterSynxisId, setFilterSynxisId] = useState('');

  const statusList = [
    { label: 'Active', value: 'Active' },
    { label: 'Archived', value: 'Archived' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Live', value: 'Live' },
  ];

  useEffect(() => {
    const storedGroup = getSelectedGroup();

    if (activeGroup?.groupId) {
      DropdownSelectedValue({
        label: activeGroup?.name,
        value: activeGroup?.groupId,
      });
    } else if (storedGroup?.value) {
      DropdownSelectedValue(storedGroup);
    }

    fetchInitialData();
  }, [propertyId, activeGroup]);

  useEffect(() => {
    if (SelectedValue?.value) {
      setGroupId(SelectedValue.value);
      fetchPropertiesByGroup(SelectedValue.value);
    }
  }, [SelectedValue]);
  const fetchInitialData = () => {
    setLoading(true);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_CheckUser_Property}/${getUserID()}`,
    })
      .then(() => {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Groups}/${getUserID()}`,
        })
          .then((res) => {
            setGroupsList(res.data);
            getGroupCurrency(res.data);
            setLoading(false);
          })
          .catch(() => setLoading(false));
      })
      .catch(() => history?.push('/app/error'));
  };

  const fetchPropertiesByGroup = (groupId) => {
    setLoading(true);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_List}?group_id=${groupId}`,
    })
      .then((res) => {
        setPropertiesList(res.data);
        setLoading(false);
      })
      .catch((err) => setLoading(false));
  };

  const getGroupCurrency = (list) => {
    if (!SelectedValue?.value) return;
    const group = list.length > 0 && list.find((g) => g.groupId === SelectedValue.value);
    setGroupCurrency(group?.currency || '');
  };

  if (loading) {
    return (
      <Card className="d-flex flex-row mb-3">
        <CardBody>
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        </CardBody>
      </Card>
    );
  }

  const handleChange = (e) => {
    DropdownSelectedValue(e);
    setSelectedGroup(e);
    setGroupId(e.value);
    getGroupCurrency(groupList);
    fetchPropertiesByGroup(e.value);
  };

  const handleStatusChange = (selected) => {
    setSelectedStatus(selected);
  };

  const handleFilterSearch = () => {
    const statusValues = selectedStatus.map((s) => s.value.toLowerCase());

    const filtered = propertiesList.filter((property) => {
      const matchStatus =
        statusValues.length === 0 ||
        statusValues.includes(property.status?.toLowerCase());
      const matchCountry =
        !filterCountry ||
        property.country?.toLowerCase().includes(filterCountry.toLowerCase());

      const matchPropertyName =
        !filterPropertyName ||
        property.name?.toLowerCase().includes(filterPropertyName.toLowerCase());

      const matchSynxisId =
        !filterSynxisId ||
        property.providerPropertyId
          ?.toString()
          .toLowerCase()
          .includes(filterSynxisId.trim().toLowerCase());

      return (
        matchStatus &&
        matchCountry &&
        matchPropertyName &&
        matchSynxisId
      );
    });

    setFilterData(filtered);
    setIsFiltering(false);
  };

  const sortedProperties = sortPropertyListByName(
    filteredData.length > 0 ? filteredData : propertiesList
  );

  const data = sortedProperties.map((property) => ({
    name: property?.name,
    type: property?.type,
    id: property?.id,
    country: property?.country,
    status: property?.status,
    updateForm: (
      <UpdatePropertyForm
        id={property?.id}
        gptTemplate={property?.gptPromptTemplates}
        groupId={groupId}
        fetchProperties={fetchPropertiesByGroup}
        groupCurrency={groupCurrency}
      />
    ),
  }));

  const columns = [
    { Header: 'Name', accessor: 'name' },
    { Header: 'Type', accessor: 'type', className: 'pl-4' },
    { Header: 'ID', accessor: 'id' },
    { Header: 'Country', accessor: 'country', className: 'pl-4' },
    { Header: 'Status', accessor: 'status', className: 'pl-4' },
    { Header: 'Actions', accessor: 'updateForm' },
  ];

  return (
    <Fragment>
      <Row>
        <Colxx xxs={12}>
          <div>
            <Row className="mb-3 ml-2">
              <div className="w-30">
                <Select
                  className="react-select"
                  classNamePrefix="react-select"
                  name="groupId"
                  value={SelectedValue}
                  onChange={handleChange}
                  options={
                    groupList
                      ? reactSelectOptionDiffrentProWithKeyValue(
                        groupList,
                        true,
                        'groupId',
                        'name',
                        'Select Group'
                      )
                      : []
                  }
                />
              </div>
              <div className="mt-2 ml-3">
                <Button
                  size="xs"
                  color="primary"
                  onClick={() => setIsFiltering(!isFiltering)}
                >
                  <div className="d-flex">
                    <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
                    <IntlMessages id="menu.show-filter" />
                    <div className="ml-1" style={{ marginTop: '2px' }}>
                      {isFiltering ? (
                        <i className="simple-icon-arrow-up p-1"></i>
                      ) : (
                        <i className="simple-icon-arrow-down p-1"></i>
                      )}
                    </div>
                  </div>
                </Button>
              </div>
              <CreatePropertyForm
                groupId={groupId}
                groupCurrency={groupCurrency}
              />
            </Row>

            <Colxx xxs="12" md="8" className="mb-4">
              <div className="align-vertical-center">
                <b>
                  {SelectedValue &&
                    SelectedValue.label &&
                    SelectedValue.value &&
                    SelectedValue.label + ' (' + SelectedValue.value + ')'}
                </b>
              </div>
            </Colxx>
            {isFiltering && (
              <Card
                className="filter-width mt-2"
                style={{
                  zIndex: '1',
                  position: 'absolute',
                  top: '2rem',
                  left: '25rem',
                  boxShadow:
                    '0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)',
                }}
              >
                <CardBody>
                  <Colxx md="12">
                    <Row>
                      <Colxx xxs="12" md="12" className="mb-2">
                        <Input className='input_sty'
                          type="text"
                          placeholder="Filter by Country"
                          value={filterCountry}
                          onChange={(e) => setFilterCountry(e.target.value)}
                        />
                      </Colxx>
                      <Colxx xxs="12" md="12" className="mb-2">
                        <Select
                          isMulti
                          className="react-select"
                          classNamePrefix="react-select"
                          name="status"
                          placeholder="Filter by Status"
                          onChange={handleStatusChange}
                          options={
                            statusList
                              ? reactSelectOptionDiffrentPro(
                                statusList,
                                true,
                                'value',
                                'label',
                                'Select Status'
                              )
                              : []
                          }
                          value={selectedStatus}
                        />
                      </Colxx>
                      <Colxx xxs="12" md="12" className="mb-2">
                        <Input className='input_sty'
                          type="text"
                          placeholder="Filter by Property Name"
                          value={filterPropertyName}
                          onChange={(e) => setFilterPropertyName(e.target.value)}
                        />
                      </Colxx>
                      {(service === '2' || service === '5') &&
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Input className='input_sty'
                            type="text"
                            placeholder="Filter by SynXis Hotel ID"
                            value={filterSynxisId}
                            onChange={(e) => setFilterSynxisId(e.target.value)}
                          />
                        </Colxx>
                      }
                      <Colxx xxs="12" md="12">
                        <Button
                          size="xs"
                          color="primary"
                          className="mb-2 mt-2"
                          onClick={handleFilterSearch}
                        >
                          Search
                        </Button>
                        <Button
                          size="xs"
                          color="secondary"
                          className="mb-2 ml-2 mt-2"
                          onClick={() => {
                            setIsFiltering(false);
                            setSelectedStatus([]);
                            setFilterCountry('');
                            setFilterPropertyName('');
                            setFilterSynxisId('');
                            setFilterData([]);
                          }}

                        >
                          Cancel
                        </Button>
                      </Colxx>
                    </Row>
                  </Colxx>
                </CardBody>
              </Card>
            )}
            <Separator className="mb-5 " />
            <Row>
              <Colxx xxs={12}>
                <Card>
                  <CardBody>
                    {propertiesList !== null &&
                      propertiesList !== undefined &&
                      propertiesList.length > 0 && (
                        <ReactTable
                          data={data}
                          columns={columns}
                          defaultPageSize={25}
                          className="-striped -highlight"
                          filterable={false}
                          showPageJump={true}
                          showPageSizeOptions={true}
                          PaginationComponent={GroupTablePagination}
                        />
                      )}

                    {/*  className="d-flex flex-row mb-3">
              <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                  <p className="mb-1  text-small w-15 w-sm-100">
                    <b>{property.name}</b>
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {property.type}
                  </p>
                  <p className="mb-1 text-muted text-small w-50 w-sm-100">
                    {property.id}
                  </p>
                  <p className="mb-1 text-muted text-small w-20 w-sm-100">
                    {property.inventoryProvider}
                  </p>
                  <div className="w-20 w-sm-100">
                    <UpdatePropertyForm
                      id={property.id}
                      gptTemplate={property.gptPromptTemplates}
                      groupId={groupId}
                      fetchProperties={fetchProperties}
                      groupCurrency={groupCurrency}
                    />
                  </div>

                </div>

              </div> */}
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
          </div>
        </Colxx>
      </Row>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => ({
  propertyId: settings.propertyId,
});

export default injectIntl(connect(mapStateToProps)(Index));
